import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import { resultsConfig } from '@Constants/Results';
import SimpleTmpl from '@Services/SimpleTmpl';
import HttpRequest from '@Services/RequestFactory';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { DEFAULT_FIRST_ITEM, DEFAULT_LAST_ITEM } from '@Services/Results/const';
import { getOptionalParams } from '@Services/Results/helpers';

export const getDruglikenessBySubstanceId = (databaseId, xrn) => {
  return MessageBroker.send(RequestUrls.DruglikenessSubstanceDetails, { databaseId, xrn });
};

export const getStructureBySubstanceId = (databaseId, xrn) => {
  return MessageBroker.send(RequestUrls.StructureBySubstance, { databaseId, xrn });
};

export const getMarkushStructures = (id, databaseId, markushRef) => {
  return MessageBroker.send(RequestUrls.MarkushStructures, { id, databaseId, count: markushRef });
};

export const getResultMoreReactionDetails = (index, resultName, databaseId, firstItem, lastItem, order, sort, hitData) => {
  const data = { resultName, databaseId, firstItem, lastItem, context: resultsConfig.CONTEXT.reactions, hitData };
  if (order && sort) {
    data.order = order;
    data.sort = sort;
  }

  const requestUrl = { ...RequestUrls.resultMoreReactionDetails };
  requestUrl.url = SimpleTmpl.format(requestUrl.url, { index });

  return MessageBroker.send(requestUrl, data);
};

export const getRelatedResults = (type, searchParams, context) => {
  if (!type) {
    return Promise.reject(new Error('No type parameter provided'));
  }

  let requestUrl;
  let params;

  if (context === 'tgitems') {
    requestUrl = { ...RequestUrls[`view${capitalize(type)}ForTargets`] };
    params = pick(searchParams, ['index', 'databaseId', 'hitSetKey', 'resultName']);

    if (searchParams.order) {
      requestUrl.url = `${requestUrl.url}&${HttpRequest.generateUrlQuery({ order: searchParams.order })}`;
    }
  } else {
    requestUrl = RequestUrls[`viewRelated${capitalize(type)}`];
    params = {
      id: searchParams.id,
      databaseId: searchParams.databaseId,
    };
  }

  return MessageBroker.send(requestUrl, params);
};

export const getRelativeResultsForCitations = (
  itemNumber,
  context,
  resultName,
  databaseId,
  firstItemIndex,
  lastItemIndex,
  sort,
  order,
  citRefResultName,
  hitData,
  firstSubItem // Patent Family Clustering
) => {
  const params = {
    itemNumber,
    context,
    resultName,
    databaseId,
    firstItem: firstItemIndex || DEFAULT_FIRST_ITEM,
    lastItem: lastItemIndex || DEFAULT_LAST_ITEM,
  };
  const requestUrl = { ...RequestUrls.relativeResultsForCitations };
  const otherParams = getOptionalParams(sort, order, citRefResultName, hitData, firstSubItem);

  if (!isEmpty(otherParams)) {
    requestUrl.url = `${requestUrl.url}&${otherParams}`;
  }

  return MessageBroker.send(requestUrl, params);
};

export const getTargetsDetails = (data) => {
  return MessageBroker.send(RequestUrls.resultsTargetDetails, data);
};

export const logEvent = (event, payload) => {
  const requestUrl = { ...RequestUrls.logEvent };

  requestUrl.url = SimpleTmpl.format(requestUrl.url, { event });
  MessageBroker.send(requestUrl, payload);
};

export const getTitlesAbstractsForCitations = (resultName, databaseId, citationId) => {
  return MessageBroker.send(RequestUrls.titlesAbstractsForCitations, { resultName, databaseId, citationId });
};
